// extracted by mini-css-extract-plugin
module.exports = {"row":"OverviewPageFundSelector_row__3oydc"};